import React from 'react'
import { Icon, Tooltip } from 'ui-framework'
import { NavLink } from 'react-router-dom'
import { linksSocials, linksMore } from './headerConfig'
import ExternalLink from 'shared-components/ExternalLink'

export default function HeaderMoreDropdown() {
  const menuItems = linksMore.map((item) => {
    return item.external ? (
      <ExternalLink
        key={item.title}
        href={item.link}
        className="btn btn--menu"
        onClick={item.onClick}>
        <Icon className="margin-right-1" name={item.icon} size={20} />
        <span>{item.title}</span>
      </ExternalLink>
    ) : (
      <NavLink key={item.title} to={item.link} className="btn btn--menu">
        <Icon className="margin-right-1" name={item.icon} size={20} />
        <span>{item.title}</span>
      </NavLink>
    )
  })

  return (
    <Tooltip
      id="menu-more"
      className="header-dropdown panel--simple padded-15"
      place="bottom"
      clickable={true}
      effect="solid"
      isCapture={true}
      globalEventOff="click"
      data-event-off="click"
      delayHide={200}>
      {menuItems}
      <hr className="content-separator dropdown-margin" style={{ marginTop: '10px' }} />

      <div className="dropdown-margin flex-center justify-between">
        {linksSocials.map((item) => (
          <ExternalLink key={item.title} href={item.url} title={item.title}>
            <Icon name={item.icon} size={20} color="var(--color-txt-default)" />
          </ExternalLink>
        ))}
      </div>
    </Tooltip>
  )
}
